import { IApplicationState } from '../../types/redux';

export const selectIsBuildersProjectsTabEnabled = (state: IApplicationState): boolean => {
  const { buildersProjectsLocations, userGeo } = state;

  return buildersProjectsLocations.includes(userGeo.userGeo);
};
